exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:block}@media screen and (min-width:991px){:host{margin-bottom:60px;min-height:80px}}:host .col{flex-basis:fit-content}:host li:after{content:\"\";height:1.5rem;width:1.5rem;background-color:#fff;border:.2rem solid #9c8c8c;border-radius:50%;position:absolute;bottom:-3rem;right:50%;z-index:10}:host li.active:after{border:.2rem solid #7a6262}:host li.active:after,:host li.validated:after{background-color:#9c8c8c}:host .titre{color:#7a6262}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/shared/components/breadcrumb/breadcrumb.component.scss
// module id = 723
// module chunks = 0